import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RxjsService {

  constructor() { }

  private functionCallSource = new Subject();
  functionCall$ = this.functionCallSource.asObservable();

  callFunction() {
    console.log("rx close");
    this.functionCallSource.next();
  }
  
  private createNewManufacturerSubject = new BehaviorSubject<boolean>(false);
  createNewManufacturer = this.createNewManufacturerSubject.asObservable();
  
  setNew(data:boolean){
    this.createNewManufacturerSubject.next(data);
  }

}
